import type { RequestResponse } from '@/types/publicType'
import type { chargeInterface } from '@/types/apiType/rechargeType'

// 获取充值订单列表
export function getChargeList(params: {
  channelType: number
  countryCode: string
}): Promise<RequestResponse<chargeInterface[]>> {
  return getFetchData({
    url: '/pay/base/charge/list',
    method: 'GET',
    params
  })
}

// 创建订单
export function createRechargeOrder(data: {
  chargeProdId: string
  countryCode: string
  paymentType: string
  app: 'web'
}) {
  return getFetchData({
    url: '/pay/base/generate/order',
    method: 'POST',
    data
  })
}

// 获取结果
export function getRechargeOrderResult(params: { chargeRecordId: string }) {
  return getFetchData({
    url: '/pay/base/results/show',
    method: 'GET',
    params
  })
}
